import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";
import { SupportAnalyticsReport } from "@redotech/redo-support-common/support/analytics/support-analytics";
import { ConversationPlatform } from "@redotech/redo-support-conversation-protocol-common/conversation-protocol";

/**
 * POST /config/facebook
 */
export async function selectFacebookPage(
  client: RedoMerchantClient,
  { pageNames, signal }: { pageNames: string[]; signal?: AbortSignal },
) {
  return await client.client.post(
    "support/config/facebook",
    { pageNames },
    { headers: client.authorization(), signal },
  );
}

/**
 * DELETE /config/facebook
 */
export async function deleteFacebookIntegration(
  client: RedoMerchantClient,
  { pageId, signal }: { pageId: string; signal?: AbortSignal },
) {
  const response = await client.client.delete(
    `support/config/facebook/${pageId}`,
    { headers: client.authorization(), signal },
  );
  return response.data;
}

/**
 * POST /config/instagram
 */
export async function selectFacebookPageWithInstagram(
  client: RedoMerchantClient,
  { pageNames, signal }: { pageNames: string[]; signal?: AbortSignal },
) {
  return await client.client.post(
    "support/config/instagram",
    { pageNames },
    { headers: client.authorization(), signal },
  );
}

/**
 * DELETE /config/instagram
 */
export async function deleteInstagramIntegration(
  client: RedoMerchantClient,
  { pageId, signal }: { pageId: string; signal?: AbortSignal },
) {
  const response = await client.client.delete(
    `support/config/instagram/${pageId}`,
    { headers: client.authorization(), signal },
  );
  return response.data;
}

/**
 * GET /config/meta
 */
export async function getPagesInfo(
  client: RedoMerchantClient,
  { pageIds, signal }: { pageIds: string[]; signal?: AbortSignal },
) {
  const response = await client.client.get("support/config/meta", {
    headers: client.authorization(),
    params: { pageIds: pageIds.join("|") },
    signal,
  });
  return response.data;
}

/**
 * POST /parse-email-signature
 */
export async function parseEmailSignature(
  client: RedoMerchantClient,
  { html, signal }: { html: string; signal?: AbortSignal },
) {
  const response = await client.client.post(
    "support/parse-email-signature",
    { html },
    { headers: client.authorization(), signal },
  );
  return response.data;
}

/**
 * GET /analytics
 */
export async function getSupportAnalytics(
  client: RedoMerchantClient,
  {
    dateRange,
    platform,
    signal,
  }: {
    dateRange: { start: Date; end: Date };
    platform?: ConversationPlatform;
    signal?: AbortSignal;
  },
): Promise<SupportAnalyticsReport> {
  const response = await client.client.get("support/analytics", {
    headers: client.authorization(),
    params: {
      start: dateRange.start.toISOString().split("T")[0],
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      end: dateRange.end.toISOString().split("T")[0],
      platform,
    },
    signal,
  });
  return response.data;
}

/**
 * POST /facebook-comments
 */
export async function toggleFacebookComments(
  client: RedoMerchantClient,
  { enabled, signal }: { enabled: boolean; signal?: AbortSignal },
): Promise<{ enabled: boolean }> {
  const response = await client.client.post(
    "support/facebook-comments",
    { enabled },
    { headers: client.authorization(), signal },
  );
  return response.data;
}

/**
 * POST /default-email
 */

export async function setDefaultEmail(
  client: RedoMerchantClient,
  {
    email,
    teamId,
    signal,
  }: { email: string; teamId: string; signal?: AbortSignal },
): Promise<{ email: string }> {
  const response = await client.client.post(
    "support/config/default-email",
    { email, teamId },
    { headers: client.authorization(), signal },
  );
  return response.data;
}
